export const TEMPLATE_START = 'template/template-start';
export const TEMPLATE_SUCCESS = 'template/template-success';
export const TEMPLATE_ERROR = 'template/template-error';
